import e from"react";var t=function(){return e.createElement("svg",{width:"18",height:"18",viewBox:"0 0 18 18",fill:"none",xmlns:"http://www.w3.org/2000/svg"},e.createElement("path",{d:"M0.762207 17.5L3.76221 0.5L17.7622 8.5L0.762207 17.5Z",fill:"#6669FF"}))};export{t as default};
//# sourceMappingURL=Triangle.js.map
